import { Component, inject, ViewChild } from '@angular/core';
import { BaseFormControlComponent } from 'src/app/features/bizzmine/form/classes/base-form-control.component';
import { ComboBoxComponent, MultiSelectComponent, SharedModule } from '@progress/kendo-angular-dropdowns';
import { NgClass } from '@angular/common';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { TimeRangeUnitType } from 'src/models/ts/time-range-unit-type.model';
import { CollectionFormField } from 'src/models/ts/collection-form-field.model';
import { FORMAT_EXCEPTION_FIELD_TYPES } from 'src/app/features/bizzmine/form/constants/form-constants';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'bizz-time-range-control',
  standalone: true,
  imports: [
    SharedModule,
    NgClass,
    NumericTextBoxComponent,
    ComboBoxComponent
  ],
  templateUrl: './time-range-control.component.html',
  styleUrl: './time-range-control.component.scss'
})
export class TimeRangeControlComponent extends BaseFormControlComponent {
  @ViewChild('multiSelectInput') public inputElement: MultiSelectComponent;
  private translationService = inject(TranslationService);

  public dateUnitTypes = [
    { caption: this.translationService.translate('TimeRangeUnitType.Days'), value: TimeRangeUnitType.Days },
    { caption: this.translationService.translate('TimeRangeUnitType.Months'), value: TimeRangeUnitType.Months },
    { caption: this.translationService.translate('TimeRangeUnitType.Years'), value: TimeRangeUnitType.Years }
  ];

  public unitTypeValue: { caption: string, value: TimeRangeUnitType } = {
    caption: this.translationService.translate('TimeRangeUnitType.Days'),
    value: TimeRangeUnitType.Days
  };
  public nrValue: number = 0;

  public override ngOnInit(): void {
    super.ngOnInit();
    if (this.formControl.value == undefined) {
      this.formControl.setValue({
        Value: this.nrValue,
        UnitType: this.unitTypeValue.value
      });
    } else {
      const defaultUnitType = this.dateUnitTypes.find((unit) => unit.value === this.formControl.value.UnitType);
      if (defaultUnitType)
        this.unitTypeValue = defaultUnitType;

      this.nrValue = this.formControl.value.Value;
    }
  }

  public onUnitTypeChange(value: { caption: string, value: TimeRangeUnitType }): void {
    this.unitTypeValue = value;

    this.formControl.setValue({
      Value: this.formControl.value.Value,
      UnitType: value.value
    });
  }

  public onNrValueChange(value: number): void {
    this.formControl.setValue({
      Value: value,
      UnitType: this.unitTypeValue.value
    });
  }

  // TODO: Once unit tests are in place, test this formatting method
  /**
   * Creates the correct format for numeric inputs.
   * Is an empty String in case of a limited set of protected field types.
   * @param {CollectionFormField} field
   * @returns {string}
   */
  public format(field: CollectionFormField): string {
    if (!FORMAT_EXCEPTION_FIELD_TYPES.includes(field.ProtectedFieldType)) {
      return `n${field.MaxDecimals}`;
    }

    return '';
  }

  protected override valueSetter(field: CollectionFormField) {
    super.valueSetter(field);
    this.nrValue = field.Value?.Value ?? 0;
    if (field.Value?.UnitType !== undefined) {
      const newUnitType = this.dateUnitTypes.find((unit) => unit.value === field.Value.UnitType);
      if (newUnitType !== undefined)
        this.unitTypeValue = newUnitType;
      else throw new Error(`Cannot find unittype of value: ${field.Value.UnitType}`);
    } else this.unitTypeValue = this.dateUnitTypes[0];
    this.unitTypeValue = field.Value?.UnitType !== undefined ? this.dateUnitTypes.find((unit) => unit.value === field.Value.UnitType)! : this.dateUnitTypes[0];
  }

  protected override focus(): void {
    this.inputElement.focus();
  }
}